module.exports = __webpack_public_path__ + "static/media/icn_close_tags.45754105.svg";